import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-751206cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_4 = { class: "fs-4" }
const _hoisted_5 = { class: "input-group w-md-25 mb-4" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value", "label"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "d-flex justify-content-end gap-10 mt-4" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import { ref, onMounted, computed } from "vue";
import PaymentService from "../services/PaymentService";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentServiceInstruction',
  props: {
  paymentServiceId: {
    type: Number,
    required: true,
  },
  closeFunction: Function,
},
  setup(__props) {

const props = __props;



const isLoading = ref(true);
const instructionList = ref(Array<any>());
const langOptions = ref<any>([]);
const langItem = ref<any>("");

const uploadImg = async (file: any) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await PaymentService.uploadImage(formData);
  return res["url"];
};

const fetchData = async () => {
  isLoading.value = true;
  const paymentId = computed(() => props.paymentServiceId);

  try {
    const responseBody = await PaymentService.getPaymentMethodInstructionById(
      paymentId.value
    );
    instructionList.value = responseBody;

    populateLangOptions();
  } catch (error) {
    console.log(error);
  }

  isLoading.value = false;
};

const save = async () => {
  isLoading.value = true;
  try {
    await PaymentService.updatePaymentMethodInstructionById(
      props.paymentServiceId,
      instructionList.value
    );
    MsgPrompt.success("Save successfully");
  } catch (error) {
    MsgPrompt.error("Save failed");
  }
  isLoading.value = false;
};

const close = () => {
  props.closeFunction();
};

const addLang = () => {
  if (Object.keys(instructionList.value).length < LanguageTypes.all.length) {
    instructionList.value[langItem.value] = "content";
    populateLangOptions();
  }
};

const canAddLang = computed(() => {
  return Object.keys(instructionList.value).length < LanguageTypes.all.length;
});

const populateLangOptions = () => {
  const instructionKeys = Object.keys(instructionList.value);
  langOptions.value = LanguageTypes.all.filter(
    (lang) => !instructionKeys.includes(lang.code)
  );
  if (langOptions.value.length > 0) {
    langItem.value = langOptions.value[0].code;
  }
};

const modules = [
  {
    name: "imageUploader",
    module: ImageUploader,
    options: {
      upload: (file) => {
        return uploadImg(file);
      },
    },
  },
  {
    name: "blotFormatter",
    module: BlotFormatter,
  },
];

onMounted(async () => {
  await fetchData();

  if (langOptions.value.length > 0) {
    langItem.value = langOptions.value[0].code;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingRing)
      ]))
    : (!isLoading.value && instructionList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(NoDataBox)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("title.updatePaymentServiceInstruction")), 1),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((langItem).value = $event)),
              disabled: !canAddLang.value
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.code,
                  value: item.code,
                  label: item.code + '   (' + item.name + ')'
                }, null, 8, _hoisted_7))
              }), 128))
            ], 8, _hoisted_6), [
              [_vModelSelect, langItem.value]
            ]),
            _createElementVNode("button", {
              class: "btn btn-success",
              onClick: addLang,
              disabled: !canAddLang.value
            }, _toDisplayString(_ctx.$t("action.addALanguage")), 9, _hoisted_8)
          ]),
          _createVNode(_component_el_tabs, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instructionList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: index,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_openBlock(), _createBlock(_unref(QuillEditor), {
                        key: index,
                        theme: "snow",
                        content: instructionList.value[index],
                        "onUpdate:content": ($event: any) => ((instructionList.value[index]) = $event),
                        contentType: "html",
                        modules: modules,
                        toolbar: "full"
                      }, null, 8, ["content", "onUpdate:content"]))
                    ])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _withModifiers(close, ["prevent"])
            }, _toDisplayString(_ctx.$t("action.close")), 9, _hoisted_10),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _withModifiers(save, ["prevent"])
            }, _toDisplayString(_ctx.$t("action.save")), 9, _hoisted_11)
          ])
        ]))
}
}

})